__turbopack_context__.v({
  "aboutButton": "styles-module-scss-module__c1Tg5q__aboutButton",
  "auctionIcon": "styles-module-scss-module__c1Tg5q__auctionIcon",
  "exapandableSectionContainer": "styles-module-scss-module__c1Tg5q__exapandableSectionContainer",
  "expandableSection": "styles-module-scss-module__c1Tg5q__expandableSection",
  "infoPage": "styles-module-scss-module__c1Tg5q__infoPage",
  "introRow": "styles-module-scss-module__c1Tg5q__introRow",
  "introText": "styles-module-scss-module__c1Tg5q__introText",
  "legend": "styles-module-scss-module__c1Tg5q__legend",
  "legendIcon": "styles-module-scss-module__c1Tg5q__legendIcon",
  "legendItem": "styles-module-scss-module__c1Tg5q__legendItem",
  "mainTitle": "styles-module-scss-module__c1Tg5q__mainTitle",
  "qrBlock": "styles-module-scss-module__c1Tg5q__qrBlock",
  "sectionTitle": "styles-module-scss-module__c1Tg5q__sectionTitle",
  "tagContainer": "styles-module-scss-module__c1Tg5q__tagContainer",
  "textContent": "styles-module-scss-module__c1Tg5q__textContent",
});
